import { render } from "./CustomerSelectionModal.vue?vue&type=template&id=07a8e1ca&scoped=true"
import script from "./CustomerSelectionModal.vue?vue&type=script&lang=js"
export * from "./CustomerSelectionModal.vue?vue&type=script&lang=js"

import "./CustomerSelectionModal.vue?vue&type=style&index=0&id=07a8e1ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a8e1ca"],['__file',"CustomerSelectionModal.vue"]])

export default __exports__